module.exports = __webpack_public_path__ + "assets/pdf/E05-en-satellite-instrument.534d4a9f.pdf";